import React from "react";
import { NavLink } from "react-router-dom";

const Banner = () => {
  return (
    <section className="pros-banner tw-bg-gradient-to-b tw-from-indigo-50/30 tw-to-white lg:tw-bg-transparent" id="prospecting-search-banner">
      <div className="max-container">
        <div className="padd-90">
          <div className="text-center banner-grp-sec">
            <h1 className="heading39px roboto-bold mb10 text-color-131415 tw-tracking-tight tw-leading-tight">
              The Smarter Way to Find Your Next{" "}
              <span className="text-primary-color">Big Client!</span>
            </h1>
            <p className="heading16px roboto-regular mb30 tw-text-slate-600 tw-tracking-wide tw-leading-relaxed">
              Find the right prospects and engage them with targeted email
              campaigns.
            </p>

            <ul className="btn-sec">
              <li>
                <NavLink
                  to={"/signup"}
                  className="common-btn-class main-btn-primary roboto-regular tw-inline-flex tw-items-center tw-justify-center tw-transition-all tw-duration-300 hover:tw-scale-[1.05] hover:tw-shadow-lg hover:tw-shadow-indigo-500/30 active:tw-scale-[0.98]"
                >
                  Get Started
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
